import { FC, useRef } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { RouteMap } from '@/routes/Routes';
import { usePlanFeatureSync } from '@/hooks/usePlanFeatureSync';

const ProtectedRoute: FC = () => {
  const { userLoggedIn, loading } = useAuthStore();
  const location = useLocation();
  // Set once a session renders here, so a sign-out from inside the app (Delete
  // Account) keeps the clean next login doSignOut asks for.
  const hadSessionRef = useRef(false);

  // Sync plan features with extension when user is logged in
  usePlanFeatureSync();

  if (loading) {
    return null;
  }

  if (!userLoggedIn) {
    // Bring a signed-out visitor back to the page they opened once they log in.
    // authStore's redirectToLogin only saves it on a cold load, and skips even
    // that for 10s after a sign-out — any other way in landed them on Home.
    // Root is skipped: it only forwards to Home, and the login page's logo
    // links there, which would overwrite a destination saved before /login.
    if (!hadSessionRef.current && location.pathname !== RouteMap.ROOT) {
      sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    }
    return <Navigate to={RouteMap.LOGIN} />;
  }

  hadSessionRef.current = true;
  return <Outlet />;
};

export default ProtectedRoute;
